import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "LL"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-persona',
  templateUrl: './persona.component.html',
  styleUrls: ['./persona.component.scss'],
  providers:[DatePipe , {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class PersonaComponent   {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;

  formulario : FormGroup;

  constructor(private loginService:LoginService, private datePipe: DatePipe) {
    this.formulario = new FormGroup({



      // proveedorNombre_Comercial
      TipoEmpresa: new FormControl('P', [Validators.required]),
      Razon_Social: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Num_Doc_Identificacion: new FormControl('', [Validators.required, Validators.pattern("[0-9]{11}$")]),
      Nombre_Comercial: new FormControl('', [Validators.required, Validators.pattern("[a-zA-Z\\s\\.\\-]+$")]),
      Tipo_Doc_Identificacion: new FormControl('', [Validators.required]),
      Direccion_Fiscal: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Departamento: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Provincia: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Distrito: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Pais: new FormControl('', [Validators.required]),
      UBIGEO: new FormControl('', [Validators.required]),
      Scoring_Puntaje: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Scoring_Fecha_Consulta: new FormControl({ value:  this.datePipe.transform(Date(),"yyyy-MM-dd"), disabled: true }, [Validators.required]),
      Estado: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Condicion: new FormControl('', [Validators.required]),
      IGV_Exonerado: new FormControl('', [Validators.required]),
      Alta_Fecha: new FormControl('', [Validators.required]),
      Fecha_Adjuntos: new FormControl( this.datePipe.transform(Date(),"yyyy-MM-dd"), []),
      Alta_Usuario : new FormControl("Gorrion", []),
      Adjunto_Ficha_Ruc : new FormControl("", []),
      Adjunto_Copia_Literal : new FormControl("", []),
      Alta_Canal : new FormControl("B", []),
      Modificaion_Fecha: new FormControl('', []),
      Modificaion_Canal: new FormControl('', []),
      Modificaion_Usuario: new FormControl('', []),
     
    });
   }


  clickGuard(){
    this.loginService.clickGuard = true;
 }

}
